import { Box, Image, Text } from "@chakra-ui/react";
import React from "react";
import { ReferralLinkIcon } from "../../../assets/images";
import { Link, useLocation } from "react-router-dom";

import useCleverTap, { CleverTapEvents, ButtonTypes } from "../../../clevertap/useCleverTap";
import { sendTrackingEvent } from "../utils/gtm";
const ReferralButton = () => {
  const clevertap = useCleverTap()[0];
  const location = useLocation();
  return (
    <Link
      onClick={() => {
        sendTrackingEvent({ event: "dash-my_referrals", eventLabel: location.pathname });
        clevertap.fireEvent(CleverTapEvents.click_my_referral, {
          screen_name: location.pathname,
          button_text: "my referrals",
          screen_position: "header",
          button_type: ButtonTypes.secondary,
        });
      }}
      to={"/profile/referrals"}
    >
      <Box cursor={"pointer"} d={"flex"} minW={"150px"} alignItems={"center"}>
        <Image boxSize={{ base: "16px", md: "24px" }} src={ReferralLinkIcon} mr={"ms-8"} />
        <Text textStyle={"btn-sm"} color={"ms-blue.500"}>
          my referrals
        </Text>
      </Box>
    </Link>
  );
};

export default ReferralButton;
